import Immutable from 'immutable';
import * as _ from 'lodash';

function getMonth(month, short) {
  const months = short
    ? ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
    : [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
      ];

  return months[month];
}

function getDayOrdinalSuffix(day) {
  const j = day % 10;
  const k = day % 100;

  if (j === 1 && k !== 11) {
    return 'st';
  }

  if (j === 2 && k !== 12) {
    return 'nd';
  }

  if (j === 3 && k !== 13) {
    return 'rd';
  }

  return 'th';
}

function toImmutable(obj, reviver) {
  return Immutable.fromJS(obj, reviver);
}

function toGreedyImmutable(obj) {
  if (_.isArray(obj)) {
    return Immutable.List(Immutable.Seq.Indexed(obj).map(toGreedyImmutable));
  }

  if (_.isObject(obj)) {
    return Immutable.Map(Immutable.Seq.Keyed(obj).map(toGreedyImmutable));
  }

  // Primitive types
  return obj;
}

function isEmail(email) {
  const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return re.test(email);
}

function isDomain(domain) {
  const re = /^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,6}?$/i;
  return re.test(domain);
}

_.mixin({
  getMonth,
  getDayOrdinalSuffix,
  toImmutable,
  toGreedyImmutable,
  isEmail,
  isDomain,
});
